import { render, staticRenderFns } from "./UpdateOrg.vue?vue&type=template&id=d84800b4&"
import script from "./UpdateOrg.vue?vue&type=script&lang=js&"
export * from "./UpdateOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateOrg.vue"
export default component.exports